import { useMutation } from '@tanstack/react-query';
import { apiService, SyncCredentials, SyncResults } from '../services/api';
import toast from 'react-hot-toast';

export const useSyncPrograms = () => {
  return useMutation({
    mutationFn: (credentials: SyncCredentials) => apiService.syncPrograms(credentials),
    onSuccess: (results: SyncResults) => {
      toast.success(`Sync completed! Created: ${results.created}, Updated: ${results.updated}`);
    },
    onError: (error: any) => {
      toast.error(`Sync failed: ${error.response?.data?.message || error.message}`);
    },
  });
}; 